const CategoryStatusBadge = ({
  isActive
}) => {
  return (
    <span
      className={`category-status-badge ${
        isActive
          ? "category-status-active"
          : "category-status-inactive"
      }`}
    >
      {isActive ? "Active" : "Inactive"}
    </span>
  );
};

export default CategoryStatusBadge;